import '../newstyle/css/aila-services-document.scss';

$(document).ready(function() {
  var serviceId            = $('#editorContainer').data('service-id');
  var serviceType          = $('#editorContainer').data('service-type');
  var serviceProcessStatus = $('#editorContainer').data('process-status');
  var servicePaymentStatus = $('#editorContainer').data('payment-status');

  console.info("Service ID:", serviceId || '---');
  console.info("Service Type:", serviceType || '---');
  console.info("Service Process Status:", serviceProcessStatus || '---');
  console.info("Service Payment Status:", servicePaymentStatus || '---');

  var modalUpload  = $('#modalUpload');
  var modalPayment = $('#modalPayment');

  if (modalUpload.length > 0) {
    if (serviceProcessStatus && serviceProcessStatus !== 'finished') {
      modalUpload.find('.loader').show();
      setInterval(checkStatus, 5000);
    } else {
      modalUpload.find('.loader').hide();
    }
  
    if (serviceProcessStatus && serviceProcessStatus === 'finished') {
      modalUpload.find('.document-upload-overlay').hide();
    }
  }

  if (modalPayment.length > 0) {
    if (servicePaymentStatus && servicePaymentStatus !== 'payed') {
      modalPayment.show();
      setInterval(checkStatus, 5000);
    } else {
      modalPayment.hide();
    }
  }

  // Validação do formulário
  // O rails-ujs desabilita o botao (data-disable-with) assim que o submit
  // dispara. Se barramos o envio, a pagina nao navega e o botao ficaria travado.
  function releaseSubmitButton() {
    const button = $('#submit-btn');
    if (!button.length) return;

    setTimeout(function() {
      const original = button.attr('data-ujs-enable-with');
      if (typeof original !== 'undefined') {
        // <button> guarda o rotulo no innerHTML; <input>, no value.
        if (button.prop('tagName') === 'BUTTON') {
          button.html(original);
        } else {
          button.val(original);
        }
        button.removeAttr('data-ujs-enable-with');
      }
      button.prop('disabled', false).removeAttr('disabled').removeClass('is-loading');
    }, 0);
  }

  // Estado de envio do botao. Fica no document (fase de bolha), entao roda
  // depois dos handlers do proprio form e enxerga se algum deles barrou o envio.
  document.addEventListener('submit', function(e) {
    if (e.target.id !== 'uploadDocForm') return;
    if (e.defaultPrevented) return;

    const button = document.getElementById('submit-btn');
    if (button) button.classList.add('is-loading');
  });

  $('#uploadDocForm').on('submit', function(e) {
    const fileKey = $('#file-key').val();
    
    // Verifica se o arquivo foi enviado para S3 (upload direto)
    if (!fileKey) {
      e.preventDefault();
      releaseSubmitButton();
      $('#upload-area').addClass('upload-area-focus');
      setTimeout(() => {
        $('#upload-area').removeClass('upload-area-focus');
      }, 2000);
      return false;
    }
  });

  // Trativa do upload
  $('#upload-area').on('click', function(e) {
    $("#docFile").click();
  });

  $('#upload-area').on('dragover', function(e) {
    e.preventDefault();
    $(this).addClass('upload-area-focus');
  });

  $('#upload-area').on('dragleave', function() {
    $(this).removeClass('upload-area-focus');
  });

  $('#upload-area').on('drop', function(e) {
    e.preventDefault();
    $(this).removeClass('upload-area-focus');
    
    const file = e.originalEvent.dataTransfer.files[0];
    if (file && file.name.endsWith('.docx')) {
      $('#docFile').prop('files', e.originalEvent.dataTransfer.files);
      $('.icon-uploted').show();
      $('.icon-initial').hide();
      $('.upload-text-one').text(file.name);
    }
  });

  $('#docFile').on('change', function(event) {
    const file = event.target.files[0];
    if (file) {
      $('.icon-uploted').show();
      $('.icon-initial').hide();
      $('.upload-text-one').text(file.name);
    }

    if (this.files.length > 0) {
      let fileName = this.files[0].name;
      const maxLength = 20;

      if (fileName.length > maxLength) {
        fileName = fileName.substring(0, maxLength) + '...';
      }
    }
  });

  // Evento do botão Sair
  $('#exit').on('click', function(e) {
    e.preventDefault();
    if (confirm('Deseja realmente sair? O processo ainda continua em execução.')) {
      window.location.href = '/';
    }
  });

  // Modal de serviço de pagamento
  function openModal() {
    $('#paymentServiceModal').addClass('active');
    $('body').css('overflow', 'hidden');
  }
  
  function closeModal() {
    $('#paymentServiceModal').removeClass('active');
    $('body').css('overflow', '');
  }
  
  $('#paymentButton').on('click', function() {
    openModal();
  });
  
  $('#modalCloseButton').on('click', function(e) {
    closeModal();
    e.stopPropagation();
  });
  
  $('#purchaseButton').on('click', function() {
    console.log('O processo de pagamento será adicionado aqui');
  });
});
